export function createQueryParams(params: { [key: string]: any }) {
    // Create URLSearchParams object from the params object
    const queryParams = new URLSearchParams();
    
    // Add all params to queryParams
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            queryParams.append(key, value.toString());
        }
    });
    return queryParams;
}